import React from 'react'
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore'
import { useRouter } from 'next/router'

import useFirebase from 'lib/hooks/useFirebase'
import Loading from 'lib/components/Loading'

import Recall from './Recall'

const Loader = ({ recall }) => {
  if (recall) {
    return <Recall recall={recall} />
  }

  const router = useRouter()
  const apiId = router.query.apiId

  const firebase = useFirebase()

  const [data, loading, error] = useDocumentDataOnce(
    apiId ? firebase.firestore().doc(`recalls/${apiId}`) : null,
  )

  if (loading) {
    return <Loading />
  }

  return <Recall recall={data} />
}

Loader.getInitialProps = async ({ query }) => {
  if (!process.browser) {
    const admin = eval("require('firebase-admin')")
    const snap = await admin
      .firestore()
      .doc(`recalls/${query.apiId}`)
      .get()

    return {
      recall: snap.data(),
    }
  }

  return {}
}

export default Loader
